import { render, staticRenderFns } from "./BetaBadge.vue?vue&type=template&id=9c87dade&scoped=true"
import script from "./BetaBadge.vue?vue&type=script&lang=js"
export * from "./BetaBadge.vue?vue&type=script&lang=js"
import style0 from "./BetaBadge.vue?vue&type=style&index=0&id=9c87dade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c87dade",
  null
  
)

export default component.exports